/**
 * HUB de traduções (gerado por scripts/generate-translations.sh — não editar).
 * Escolhe a variante do tipo de app em runtime (window.__NCH_ENV.APP_TYPE,
 * injetado pelo blade partials/nch-env). Fase 1 — imagem única.
 */
import freeSale from './app-translations.free_sale.js';
import jmvFlix from './app-translations.jmv_flix.js';

const appType =
    (typeof window !== 'undefined' && window.__NCH_ENV && window.__NCH_ENV.APP_TYPE) ||
    'free_sale';

export default appType === 'jmv_flix' ? jmvFlix : freeSale;
